import { render, staticRenderFns } from "./NominationCommitteeList.vue?vue&type=template&id=124d75d3"
import script from "./NominationCommitteeList.vue?vue&type=script&lang=js"
export * from "./NominationCommitteeList.vue?vue&type=script&lang=js"
import style0 from "./NominationCommitteeList.vue?vue&type=style&index=0&id=124d75d3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports